import { ForwardedRef, ReactNode } from 'react';

export interface DialogModalFooterProps {
	children: ReactNode;
}

export function DialogModalFooter({ children }: DialogModalFooterProps, ref: ForwardedRef<HTMLDivElement>): JSX.Element {
	return <div ref={ref}>{children}</div>;
}
